import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Printer, Download } from "@phosphor-icons/react";

const PARTNER_LABELS = {
  hotel: {
    hi: { role: "होटल", roleParty: "होटल का नाम", listing: "अपने कमरे (Rooms)", agreementTitle: "होटल पार्टनर एग्रीमेंट" },
    en: { role: "Hotel", roleParty: "Hotel Name", listing: "its rooms", agreementTitle: "Hotel Partner Agreement" },
  },
  room: {
    hi: { role: "मालिक", roleParty: "प्रॉपर्टी का नाम / पता", listing: "अपने रूम / फ्लैट्स (Rooms / Flats)", agreementTitle: "रूम / फ्लैट ओनर पार्टनर एग्रीमेंट" },
    en: { role: "Owner", roleParty: "Property Name / Address", listing: "its rooms / flats", agreementTitle: "Room / Flat Owner Partner Agreement" },
  },
};

function HindiAgreement({ type }) {
  const l = PARTNER_LABELS[type].hi;
  return (
    <div className="prose prose-sm max-w-none leading-relaxed">
      <h2 className="font-serif text-2xl text-midnight mb-4">{l.agreementTitle}</h2>
      <p>यह एग्रीमेंट दिनांक ___ / ___ / 20__ को निम्नलिखित पक्षों के बीच किया गया है:</p>

      <h3 className="font-semibold mt-4">प्रथम पक्ष (कंपनी)</h3>
      <p>
        कंपनी का नाम: <strong>Zyro App</strong><br/>
        पता: भारत<br/>
        ईमेल: <strong>conect@zyroapp.in</strong><br/>
        मोबाइल: <strong>+91 92625 92844</strong>
      </p>

      <h3 className="font-semibold mt-4">द्वितीय पक्ष ({l.role})</h3>
      <p>
        {l.roleParty}: ________________________<br/>
        मालिक का नाम: ______________________<br/>
        पता: _______________________________<br/>
        मोबाइल: ____________________________<br/>
        आधार संख्या: _______________________
      </p>

      <h3 className="font-semibold mt-4">1. उद्देश्य</h3>
      <p>{l.role} {l.listing} Zyro App पर सूचीबद्ध (List) करेगा ताकि ग्राहक ऑनलाइन बुकिंग कर सकें।</p>

      <h3 className="font-semibold mt-4">2. कमीशन</h3>
      <ul className="list-disc pl-5">
        <li>Zyro App प्रत्येक सफल बुकिंग पर <strong>10% कमीशन</strong> लेगा।</li>
        <li>शेष <strong>90% राशि</strong> {l.role} की होगी।</li>
        <li>कमीशन केवल सफल एवं पूर्ण हुई बुकिंग पर लागू होगा।</li>
      </ul>

      <h3 className="font-semibold mt-4">3. भुगतान</h3>
      <ul className="list-disc pl-5">
        <li>ग्राहक द्वारा किए गए भुगतान का निपटान (Settlement) दोनों पक्षों की सहमति के अनुसार किया जाएगा।</li>
        <li>{l.role} अपने बैंक खाते की सही जानकारी उपलब्ध कराएगा।</li>
      </ul>

      <h3 className="font-semibold mt-4">4. {l.role} की जिम्मेदारियाँ</h3>
      <ul className="list-disc pl-5">
        <li>सही रूम/फ्लैट, फोटो, कीमत और सुविधाओं की जानकारी देना।</li>
        <li>बुकिंग होने पर ग्राहक को कमरा/फ्लैट उपलब्ध कराना।</li>
        <li>स्वच्छता एवं सुरक्षा बनाए रखना।</li>
        <li>गलत जानकारी देने पर {l.role} स्वयं जिम्मेदार होगा।</li>
      </ul>

      <h3 className="font-semibold mt-4">5. Zyro App की जिम्मेदारियाँ</h3>
      <ul className="list-disc pl-5">
        <li>{l.role} की जानकारी ऐप पर प्रदर्शित करना।</li>
        <li>ऑनलाइन बुकिंग की सुविधा उपलब्ध कराना।</li>
        <li>ग्राहक सहायता (Customer Support) उपलब्ध कराने का प्रयास करना।</li>
      </ul>

      <h3 className="font-semibold mt-4">6. कैंसिलेशन</h3>
      <ul className="list-disc pl-5">
        <li>कैंसिलेशन एवं रिफंड {l.role} की नीति के अनुसार होगा।</li>
        <li>Zyro App आवश्यकता पड़ने पर रिफंड प्रक्रिया में सहयोग करेगा।</li>
      </ul>

      <h3 className="font-semibold mt-4">7. प्रतिबंध</h3>
      <ul className="list-disc pl-5">
        <li>{l.role} किसी भी ग्राहक से Zyro App की बुकिंग को ऑफलाइन बदलने के लिए दबाव नहीं डालेगा।</li>
        <li>किसी भी प्रकार की धोखाधड़ी पाए जाने पर Zyro App {l.role} की लिस्टिंग हटाने का अधिकार रखता है।</li>
      </ul>

      <h3 className="font-semibold mt-4">8. अवधि</h3>
      <p>यह एग्रीमेंट हस्ताक्षर की तिथि से प्रभावी होगा और किसी भी पक्ष द्वारा 30 दिन का लिखित नोटिस देकर समाप्त किया जा सकता है।</p>

      <h3 className="font-semibold mt-4">9. गोपनीयता</h3>
      <p>दोनों पक्ष एक-दूसरे की व्यावसायिक एवं ग्राहक संबंधी जानकारी गोपनीय रखेंगे।</p>

      <h3 className="font-semibold mt-4">10. विवाद</h3>
      <p>किसी भी विवाद की स्थिति में पहले आपसी सहमति से समाधान का प्रयास किया जाएगा। यदि समाधान नहीं होता है, तो संबंधित न्यायालय का क्षेत्राधिकार लागू होगा।</p>

      <h3 className="font-semibold mt-4">11. घोषणा</h3>
      <p>दोनों पक्ष इस एग्रीमेंट की सभी शर्तों को पढ़कर एवं समझकर अपनी स्वेच्छा से सहमत हैं।</p>

      <div className="mt-8 grid grid-cols-2 gap-8 text-sm">
        <div>
          <p className="mb-8">प्रथम पक्ष (Zyro App)</p>
          <p>हस्ताक्षर: ___________________</p>
          <p>नाम: ______________________</p>
          <p>दिनांक: ___________________</p>
        </div>
        <div>
          <p className="mb-8">द्वितीय पक्ष ({l.role})</p>
          <p>हस्ताक्षर: ___________________</p>
          <p>नाम: ______________________</p>
          <p>दिनांक: ___________________</p>
        </div>
      </div>
    </div>
  );
}

function EnglishAgreement({ type }) {
  const l = PARTNER_LABELS[type].en;
  return (
    <div className="prose prose-sm max-w-none leading-relaxed">
      <h2 className="font-serif text-2xl text-midnight mb-4">{l.agreementTitle}</h2>
      <p>This agreement is made on this ___ / ___ / 20__ between the following parties:</p>

      <h3 className="font-semibold mt-4">First Party (Company)</h3>
      <p>
        Company Name: <strong>Zyro App</strong><br/>
        Address: India<br/>
        Email: <strong>conect@zyroapp.in</strong><br/>
        Mobile: <strong>+91 92625 92844</strong>
      </p>

      <h3 className="font-semibold mt-4">Second Party ({l.role})</h3>
      <p>
        {l.roleParty}: ________________________<br/>
        Owner Name: ______________________<br/>
        Address: _______________________________<br/>
        Mobile: ____________________________<br/>
        Aadhaar Number: _______________________
      </p>

      <h3 className="font-semibold mt-4">1. Purpose</h3>
      <p>The {l.role} shall list {l.listing} on the Zyro App so that customers can book online.</p>

      <h3 className="font-semibold mt-4">2. Commission</h3>
      <ul className="list-disc pl-5">
        <li>Zyro App shall charge a <strong>10% commission</strong> on every successful booking.</li>
        <li>The remaining <strong>90%</strong> shall be paid to the {l.role}.</li>
        <li>Commission is applicable only on successful & completed bookings.</li>
      </ul>

      <h3 className="font-semibold mt-4">3. Payment</h3>
      <ul className="list-disc pl-5">
        <li>Settlement of the customer's payment shall be done as per mutual agreement between both parties.</li>
        <li>The {l.role} shall provide correct bank account details.</li>
      </ul>

      <h3 className="font-semibold mt-4">4. Responsibilities of the {l.role}</h3>
      <ul className="list-disc pl-5">
        <li>Provide accurate information regarding rooms/flats, photos, price, and amenities.</li>
        <li>Provide the room/flat to the customer on booking.</li>
        <li>Maintain cleanliness and safety.</li>
        <li>The {l.role} shall be solely responsible for any misinformation provided.</li>
      </ul>

      <h3 className="font-semibold mt-4">5. Responsibilities of Zyro App</h3>
      <ul className="list-disc pl-5">
        <li>Display the {l.role}'s information on the app.</li>
        <li>Provide online booking facility.</li>
        <li>Attempt to provide customer support.</li>
      </ul>

      <h3 className="font-semibold mt-4">6. Cancellation</h3>
      <ul className="list-disc pl-5">
        <li>Cancellation and refund shall be as per the {l.role}'s policy.</li>
        <li>Zyro App shall cooperate in the refund process if required.</li>
      </ul>

      <h3 className="font-semibold mt-4">7. Restrictions</h3>
      <ul className="list-disc pl-5">
        <li>The {l.role} shall not pressurise any customer to convert Zyro App bookings to offline.</li>
        <li>On finding any kind of fraud, Zyro App reserves the right to remove the {l.role}'s listing.</li>
      </ul>

      <h3 className="font-semibold mt-4">8. Term</h3>
      <p>This agreement shall be effective from the date of signature and may be terminated by either party by giving 30 days' written notice.</p>

      <h3 className="font-semibold mt-4">9. Confidentiality</h3>
      <p>Both parties shall keep each other's business and customer information confidential.</p>

      <h3 className="font-semibold mt-4">10. Dispute</h3>
      <p>In case of any dispute, resolution shall first be attempted by mutual consent. If not resolved, the jurisdiction of the concerned court shall apply.</p>

      <h3 className="font-semibold mt-4">11. Declaration</h3>
      <p>Both parties agree voluntarily after reading and understanding all the terms of this agreement.</p>

      <div className="mt-8 grid grid-cols-2 gap-8 text-sm">
        <div>
          <p className="mb-8">First Party (Zyro App)</p>
          <p>Signature: ___________________</p>
          <p>Name: ______________________</p>
          <p>Date: ___________________</p>
        </div>
        <div>
          <p className="mb-8">Second Party ({l.role})</p>
          <p>Signature: ___________________</p>
          <p>Name: ______________________</p>
          <p>Date: ___________________</p>
        </div>
      </div>
    </div>
  );
}

export default function PartnerAgreementPage() {
  const [params] = useSearchParams();
  const initialType = params.get("type") === "room" ? "room" : "hotel";
  const [type, setType] = useState(initialType);
  const [lang, setLang] = useState("both"); // "hi" | "en" | "both"

  const handlePrint = () => window.print();

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-10">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-8 print:hidden">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">Partner Onboarding</p>
          <h1 className="font-serif text-3xl text-midnight">Partner Agreement</h1>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={handlePrint} data-testid="print-agreement-btn">
            <Printer size={16} className="mr-2" /> Print / Save PDF
          </Button>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-6 print:hidden">
        <div className="flex gap-1 p-1 bg-stone rounded-full">
          <button
            onClick={() => setType("hotel")}
            data-testid="agreement-type-hotel"
            className={`px-4 py-2 rounded-full text-sm ${type === "hotel" ? "bg-midnight text-bone" : "text-neutral-600"}`}
          >Hotel Partner</button>
          <button
            onClick={() => setType("room")}
            data-testid="agreement-type-room"
            className={`px-4 py-2 rounded-full text-sm ${type === "room" ? "bg-midnight text-bone" : "text-neutral-600"}`}
          >Room / Flat Owner</button>
        </div>
        <div className="flex gap-1 p-1 bg-stone rounded-full">
          <button
            onClick={() => setLang("hi")}
            data-testid="agreement-lang-hi"
            className={`px-4 py-2 rounded-full text-sm ${lang === "hi" ? "bg-gold text-midnight" : "text-neutral-600"}`}
          >हिन्दी</button>
          <button
            onClick={() => setLang("en")}
            data-testid="agreement-lang-en"
            className={`px-4 py-2 rounded-full text-sm ${lang === "en" ? "bg-gold text-midnight" : "text-neutral-600"}`}
          >English</button>
          <button
            onClick={() => setLang("both")}
            data-testid="agreement-lang-both"
            className={`px-4 py-2 rounded-full text-sm ${lang === "both" ? "bg-gold text-midnight" : "text-neutral-600"}`}
          >Both</button>
        </div>
      </div>

      <div className="bg-white border border-black/10 rounded-3xl p-8 lg:p-12 print:border-0 print:p-0" data-testid="agreement-content">
        {(lang === "hi" || lang === "both") && <HindiAgreement type={type} />}
        {lang === "both" && <div className="my-10 border-t-2 border-dashed border-black/20 print:break-after-page" />}
        {(lang === "en" || lang === "both") && <EnglishAgreement type={type} />}
      </div>
    </div>
  );
}
